(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["margin-home"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('margin-calculator')) {
class MarginCalculator extends HTMLElement {
connectedCallback() {
if(this.ready)return; this.ready=true;
this.form=this.querySelector('form');this.words=JSON.parse(this.querySelector('[data-words]').textContent);
this.form.addEventListener('submit',e=>{e.preventDefault();this.update();});
this.form.addEventListener('input',()=>this.update());
this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.update();});this.update();
}
update(){
const values={};for(const input of this.form.querySelectorAll('input')){if(input.value.trim()===''||!input.validity.valid){this.showError(this.words.invalid);return;}values[input.name]=Number(input.value);}
const {price:p,cost:c,orders:n,discount:d,increase:g}=values;
const r=window.marginCalculate(p,c,n,d,g);
if(!r){this.showError(this.words.invalid);return;}
this.querySelector('[data-error]').hidden=true;this.querySelector('[data-results]').hidden=false;
const money=v=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(v);
const count=v=>new Intl.NumberFormat('en-AU').format(v);
const normal={sale_price:p,cost_order:c,contribution:r.b,volume:n,revenue:p*n,total:r.bt};
const promo={sale_price:r.pd,cost_order:c,contribution:r.a,volume:r.np,revenue:r.pd*r.np,total:r.at};
for(const [kind,obj] of Object.entries({normal,promo}))for(const [key,val]of Object.entries(obj))this.querySelector('[data-'+kind+'="'+key+'"]').textContent=key==='volume'?count(val):money(val);
this.querySelector('[data-delta]').textContent=(r.delta>0?'+':'')+money(r.delta);
const state=r.delta>0.005?'ahead':r.delta<-.005?'behind':'same';
this.querySelector('[data-verdict]').textContent=this.words[state].replace('{amount}',money(Math.abs(r.delta)));
this.querySelector('[data-summary]').dataset.state=state;
const warn=this.querySelector('[data-warning]');warn.hidden=r.b>0&&r.a>0;
warn.textContent=r.b<=0?this.words.baseline_warning:this.words.loss_warning;
for(const key of ['required','extra','uplift'])this.querySelector('[data-'+key+']').textContent=r.required===null?(r.b<=0?this.words.na:this.words.impossible):(key==='required'?count(r.required):key==='extra'?count(Math.max(0,r.required-n)):(Math.max(0,(r.required/n-1)*100)).toFixed(1)+'%');
}
showError(message){const el=this.querySelector('[data-error]');el.textContent=message;el.hidden=false;this.querySelector('[data-results]').hidden=true;}
}
window.marginCalculate=function(p,c,n,d,g){
if(![p,c,n,d,g].every(Number.isFinite)||p<0||c<0||n<=0||!Number.isInteger(n)||d<0||d>100||g< -100)return null;
const pd=p*(1-d/100),b=p-c,a=pd-c,np=Math.round(n*(1+g/100)),bt=b*n,at=a*np;
if(![pd,b,a,np,bt,at,at-bt].every(Number.isFinite)||!Number.isSafeInteger(np))return null;
let required=b>0&&a>0?Math.ceil(bt/a-1e-10):null;
if(required!==null&&!Number.isSafeInteger(required))required=null;
return {pd,b,a,np,bt,at,delta:at-bt,required};
};
customElements.define('margin-calculator',MarginCalculator);
}
  } catch(e) { console.error(e); }
})();
})();
